/**
 * Métodos especificos para o modo cliente
 * @type {Object}
 */
MdHub.client = {
  onReadyClient: undefined,
  /**
   * Inicia os comandos padrões para o modo cliente
   * @param  {Object} commands Lista de comandos
   */
  bindCommands: function bindCommands(commands) {
    var command;

    MdHub.command.add('core:authenticate', function add(data, resolve) {
      resolve(MdHub.module.options.authenticate);
    });

    MdHub.command.add('core:ping', function ping(data, resolve) {
      resolve(true);
    });

    // Se o módulo não possuir comandos para adicionar
    if (!commands) return;

    for (command in commands) {
      if (Object.prototype.hasOwnProperty.call(commands, command)) {
        MdHub.command.add(command, commands[command]);
      }
    }
  },

  /**
   * Inicia os eventos padrões para o modo cliente
   * * @param  {Object} events Lista de eventos
   */
  bindEvents: function bindEvents(events) {
    var event;

    // Precisa ter function no listener abaixo para funcionar no IE8
    window.addEventListener('message', function message(messageData) {
      MdHub.postMessage.receive(messageData);
    }, false);

    window.addEventListener('keyup', function keyup(e) {
      var keyPressed = {
        code: e.code,
        key: e.key
      };
      MdHub.event.trigger('core:keyupEvent', keyPressed);
    });

    // Se o módulo não possuir eventos para adicionar
    if (!events) return;

    for (event in events) {
      if (Object.prototype.hasOwnProperty.call(events, event)) {
        MdHub.event.add(event, events[event]);
      }
    }
  },

  /**
   * Inicializa uma instância do MdHub Client
   * @param  {Object} options Opções de inicialização
   * Exemplo: {
   *    name: 'Nome do módulo',
   *    version: 'Versão do Módulo',
   *    build: 'Numero do build do módulo'
   *
   *    options: {
   *      style: { // Estilos do iframe do módulo como exemplo abaixo
   *          background: 'transparent',
   *          border: '10px solid black'
   *          },
   *          transparent: true, // Se o iframe do módulo será transparente ou não
   *          authenticate: true // Se o módulo requere um usuário autenticado ou não.
   *    },
   *
   *    events: {},
   *
   *    commands: {},
   *
   *    require: []
   *  }
   */
  init: function init(module) {
    var waitPrescricaoModule = function waitPrescricaoModule() {
      setTimeout(function timeoutPrescricaoModule() {
        if (! window.prescricaoModule.initialized) {
          waitPrescricaoModule();
          return;
        }

        MdHub.event.trigger('core:moduleInit', module);
      }, 200);
    };

    if (window.location.href.indexOf('local.memed') >= 1
      || window.location.href.indexOf('dev2.memed') >= 1) {
      // eslint-disable-next-line no-console
      console.log('module.init', module);
    }

    // Se o módulo não possuir um nome
    if (!module.name) {
      // eslint-disable-next-line no-console
      console.warn('Module Init Error: Você precisa definir o nome do módulo.');
      return;
    }

    // Atribui as configurações do módulo ao Hub Client
    MdHub.mode = 'client';
    MdHub.module.build = module.build || 0;
    MdHub.module.callbacks = module.callbacks || {};
    MdHub.module.commands = module.commands || {};
    MdHub.module.events = module.events || {};
    MdHub.module.name = module.name;
    MdHub.module.options = module.options || {};
    MdHub.module.require = module.require || {};
    MdHub.module.version = module.version || 1;
    MdHub.module.onReadyClient = module.onReadyClient || undefined;

    if (module.require) {
      MdHub.command.send('hub', 'core:getRequire', MdHub.module.require);
    }

    this.bindEvents(module.events);
    this.bindCommands(module.commands);

    // As funções de eventos e comandos não são passadas pelo postMessage, por isso serão deletadas.
    // Mantido para retrocompatibilidade
    /* eslint-disable no-param-reassign */
    delete module.events;
    delete module.commands;
    
    if (module.onReadyClient) module.onReadyClient();

    // O módulo plataforma.prescricao somente pode emitir o evento
    // core:moduleInit após as suas dependências terem sido carregadas.
    // O código abaixo existe apenas por conta de que os parceiros da Memed
    // escutam esse evento para iniciar suas integrações, e caso o evento
    // seja emitido antes das dependências, o módulo poderá apresentar erros
    // em sua inicialização.
    // O hub é para ser agnóstico, e esse código uma hora deve ser removido,
    // com a integração ou o módulo gerenciando melhor essa situação.
    if (
      module.name !== 'plataforma.prescricao'
      || window.prescricaoModule.initialized
      || window.prescricaoModule.initialized === undefined
    ) {
      MdHub.event.trigger('core:moduleInit', module);
      return;
    }

    waitPrescricaoModule();
  }
};
